import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Signal,
  viewChild,
} from '@angular/core';
import { IButtonIcon } from '@core/modules/components/button-v2/button.interface';
import { PlatformService } from '@noda-lib/utils/services';
import { whatIsNodaInfo, whatIsNodaSwiper } from '@pages/main/db/main.db';
import { IWhatIsNodaInfo, IWhatIsNodaSwiper } from '@pages/main/interfaces/main.type';
import { WhatIsNodaImports } from '@pages/main/what-is-noda/what-is-noda.imports';
import { NODA_FORM_ROUTER_LINK } from '@shared/constants/links';
import { EnMaxWidthScreen, EnMinWidthScreen } from '@shared/constants/screen-breakpoints';
import type { SwiperOptions } from 'swiper';
import Swiper, { Navigation, Pagination } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

Swiper.use([Navigation, Pagination]);

@Component({
  selector: 'noda-what-is-noda',
  standalone: true,
  imports: WhatIsNodaImports,
  templateUrl: './what-is-noda.component.html',
  styleUrl: './what-is-noda.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatIsNodaComponent implements AfterViewInit {
  public config: SwiperOptions = {
    slidesPerView: 1,
    grabCursor: true,
    loop: false,
    navigation: {
      nextEl: '.what-right',
      prevEl: '.what-left',
    },
    pagination: {
      el: '.main-noda__pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 8,
      },
      768: {
        spaceBetween: 16,
      },
      1024: {
        spaceBetween: 24,
      },
      1440: {
        spaceBetween: 48,
      },
    },
  };

  private platformService: PlatformService = inject(PlatformService);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private swiper: Signal<SwiperComponent> = viewChild(SwiperComponent);
  public readonly whatIsNodaSwiper: IWhatIsNodaSwiper[] = whatIsNodaSwiper;
  public readonly whatIsNodaInfo: IWhatIsNodaInfo[] = whatIsNodaInfo;
  public readonly minWidthScreen: typeof EnMinWidthScreen = EnMinWidthScreen;
  public readonly enMaxWidthScreen: typeof EnMaxWidthScreen = EnMaxWidthScreen;
  public readonly buttonLink: string = NODA_FORM_ROUTER_LINK;
  public icon: IButtonIcon = { position: 'right', name: 'arrow_drop_right' };

  ngAfterViewInit(): void {
    if (this.platformService.isBrowser()) {
      queueMicrotask(() => {
        this.initSwiperPagination();
      });
    }
  }

  private initSwiperPagination(): void {
    if (this.swiper()?.swiperRef) {
      const swiperRef = this.swiper().swiperRef;

      swiperRef.pagination.init();
      swiperRef.pagination.render();
      swiperRef.pagination.update();
      this.destroyRef.onDestroy(() => {
        swiperRef.destroy();
      });
    }
  }

  public getIconName(name: string): string {
    return `main/${name}.svg#${name}`;
  }
}
